<template>
  <section>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-9">
            <base-editor
              v-model="formGroup.terms_and_condition.value"
            ></base-editor>
          </div>
        </div>
      </div>
    </div>
    <base-button
      :loading="loading"
      type="primary"
      class="showButton"
      @click="saveData"
    >
      Submit
    </base-button>

    <progress-loader :show="showProgress" :no-wrap="true"></progress-loader>
  </section>
</template>

<script>
import { FormGroup, Text } from "@/core/models";
import SettingMixin from "@/core/mixins/setting.mixin";
import { settingService, notificationService } from "@/core/services";
import { SETTING } from "@/core/enums";

export default {
  name: "TermsAndCondiition",

  mixins: [SettingMixin],
  props: {
    model: {
      type: Object,
      default: () => {
        return new Text();
      },
    },
  },
  data() {
    return {
      test: "",
      loading: false,
      formGroup: new FormGroup({
        terms_and_condition: [null],
      }),
      settingType: SETTING.TERMSANDCONDITION,
    };
  },
  watch: {
    model(newVal, _oldVal) {
      if (newVal) {
        this.formGroup.terms_and_condition.value = newVal.terms_and_condition;
      }
    },
  },
  methods: {
    saveData() {
      const form = this.formGroup.value;
      const payload = {
        type: this.settingType,
        data: { ...this.model, ...form },
      };

      this.loading = true;
      settingService
        .saveDetails(payload)
        .then((res) => {
          notificationService.success(res.message);
          this.test = "";
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.showButton {
  margin-top: 2em;
}
</style>
